import { FlexProps, spacing } from 'deepstash-ui';
import React from 'react';
import { UserStash } from 'types/models';
import { GAP_SIZE, getRemWidthFromColumns } from 'utils/global';
import GroupCardSvg from '../cards/GroupCardSvg';
import FullWidthScrollableWrapper from '../layout/components/FullWidthScrollableWrapper';
import FullWidthSectionWrapper from '../layout/components/FullWidthSectionWrapper';
import SectionTitle, {
  SectionTitleProps,
} from '../layout/components/SectionTitle';

interface ItemCarouselProps<T> extends FlexProps {
  items: T[];
  itemRenderer?: (props: { item: T; index: number }) => JSX.Element;
  sectionTitle?: SectionTitleProps;
}

// TODO - refactor this component to accept a header renderer defaulting to SectionTitle
// and an item renderer defaulting to GroupCardSvg
// and a generic type for the item renderer and another for the header renderer

const DEFAULT_ITEM_RENDERER = <T extends UserStash>({
  item,
  index,
}: {
  item: T;
  index: number;
}) => {
  return (
    <GroupCardSvg
      data={item}
      dataType="collection"
      key={index}
      width={{
        base: spacing.toRem(216),
        md: getRemWidthFromColumns(3),
      }}
      withLink
    />
  );
};

const CollectionCarousel = <T extends UserStash>({
  items,
  itemRenderer = DEFAULT_ITEM_RENDERER,
  sectionTitle,
  ...props
}: ItemCarouselProps<T>) => {
  return (
    <>
      {sectionTitle && (
        <FullWidthSectionWrapper
          marginTop={
            props.mt ?? props.marginTop ?? spacing.toRem(GAP_SIZE * 1.5)
          }
        >
          <SectionTitle {...sectionTitle} />
        </FullWidthSectionWrapper>
      )}
      <FullWidthScrollableWrapper>
        {items.map((item, index) =>
          itemRenderer
            ? itemRenderer({ item, index })
            : DEFAULT_ITEM_RENDERER({ item, index }),
        )}
      </FullWidthScrollableWrapper>
    </>
  );
};

export default CollectionCarousel;
